import classNames from 'classnames';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import CrossIcon from '../icons/Cross';
import IconLink from './IconLink';

import styles from '../../../styles/partials/active-filters-buttons.module.scss';

const propTypes = {
    filters: AppPropTypes.filters,
    query: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    onChange: PropTypes.func,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    isDark: PropTypes.bool,
};

const defaultProps = {
    filters: null,
    query: null,
    onChange: null,
    className: null,
    buttonClassName: null,
    isDark: false,
};

const ActiveFiltersButtons = ({ query, filters, onChange, className, buttonClassName, isDark }) => {
    if (Object.keys(query).length === 0) return false;

    const actives = Object.keys(query).reduce((acc, filterId) => {
        const {
            id = null,
            multiple = false,
            options = [],
            letters = [],
        } = filters.find((it) => it !== null && it.id === filterId) || {};

        const queryValue = query[filterId] ? query[filterId] : [];

        const values = multiple && isArray(queryValue) ? queryValue : [queryValue];

        const other = values
            .map((v) => {
                const letter = letters.find((value) => value === v) || null;
                if (letter !== null) {
                    return { label: letter, value: v, type: id, multiple };
                }
                const option =
                    options.find(({ value, url = null }) => value === v && url === null) || null;
                return option !== null
                    ? { label: option.label, value: v, type: id, multiple }
                    : null;
            })
            .filter((it) => it !== null);

        return id !== null ? [...acc, ...other] : acc;
    }, []);

    if (actives.length === 0) {
        return null;
    }

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isDark]: isDark,
                },
            ])}
        >
            <div className={styles.inner}>
                {actives.map(({ id, label, value, type, multiple }, idx) => {
                    const onRemoveFilter = () => {
                        const newValues =
                            multiple && isArray(query[type])
                                ? query[type].filter((v) => v !== value)
                                : null;
                        if (query !== null && onChange !== null) {
                            const newQuery =
                                newValues !== null && newValues.length > 0
                                    ? { ...query, [type]: newValues }
                                    : Object.keys(query).reduce(
                                          (acc, key) =>
                                              key !== type ? { ...acc, [key]: query[key] } : acc,
                                          {},
                                      );
                            onChange(Object.keys(newQuery).length > 0 ? newQuery : null);
                        }
                    };

                    return (
                        <IconLink
                            key={`${id}-${value}-${type}-${idx + 1}`}
                            className={classNames([
                                styles.button,
                                { [buttonClassName]: buttonClassName !== null },
                            ])}
                            iconClassName={styles.buttonIcon}
                            icon={onChange !== null ? <CrossIcon /> : null}
                            iconPosition="right"
                            onClick={onRemoveFilter}
                            isDark={isDark}
                        >
                            {label}
                        </IconLink>
                    );
                })}
            </div>
        </div>
    );
};

ActiveFiltersButtons.propTypes = propTypes;
ActiveFiltersButtons.defaultProps = defaultProps;

export default ActiveFiltersButtons;
